<template>
  <BaseModal ref="modal" modal-classes="max-w-md mx-auto" @modal-after-leave="$emit('closed')">
    <template #header>
      <span class="block text-xs text-gray-700 uppercase tracking-wider">
        τροποποιηση αναβαθμισης
      </span>
      <h3 class="text-2xl text-gray-900">
        {{ productServiceUpgrade.name }}
      </h3>
    </template>

    <template #default="modalProps">
      <FormProductServiceUpgrade
        :product-service-uuid="productServiceUpgrade.upgradesProductServiceUuid"
        :product-service-upgrade-uuid="productServiceUpgrade.uuid"
        @success="modalProps.close"
        @cancel="modalProps.close"
      />
    </template>
  </BaseModal>
</template>

<script>
import FormProductServiceUpgrade from './FormProductServiceUpgrade.vue';

export default {
  name: 'ModalUpdateUpgrade',
  components: {
    FormProductServiceUpgrade,
  },
  props: {
    productServiceUpgrade: {
      type: Object,
      required: true,
    },
  },
};
</script>
